module.exports = __webpack_public_path__ + "img/top03.733f5d02.png";